export default __webpack_public_path__ + "b0becd30b7f9acabf71fa40d52f1f765.svg";